import React from 'react';
import { Container } from './styles';
import { Tooltip } from 'antd';
import { InfoCircleOutlined, LoadingOutlined } from '@ant-design/icons';
import { Props } from './types';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../../../../store';
import DetalhesOcorrencia from '../../modalDetalhesOcorrencia';

const CardDesktop: React.FC<Props> = ({ color, title, info, quantity, protocolo }) => {
  const loading = useSelector((state: ApplicationState) => state.Semaphore?.loading);
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  return (
    <Container color={color} data-testid="cardDesktop">
      <DetalhesOcorrencia
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        protocolos={protocolo || []}
      />

      <div className="containerTF">
        <h2 className="title">{title}</h2>{' '}
        <span className="icon">
          <Tooltip title={info}>
            {<InfoCircleOutlined role="tooltip" style={{ cursor: 'pointer' }} />}
          </Tooltip>
        </span>
      </div>

      <div className="quantity">
        {loading ? (
          <LoadingOutlined style={{ color: '#FFF' }} />
        ) : (
          <Tooltip
            title={
              protocolo && protocolo?.length > 0 ? (
                <>
                  <h3 style={{ color: '#FFF' }}>Potocolo(s) da(s) ocorrência(s)</h3>
                  {protocolo?.map((item) => (
                    <span>{item}, </span>
                  ))}
                </>
              ) : (
                'Nenhum protocolo encontrado'
              )
            }
          >
            <span onClick={() => setIsModalOpen(true)} style={{ cursor: 'pointer' }}>
              {quantity?.toString()?.padStart(2, '0')}
            </span>
          </Tooltip>
        )}
      </div>
    </Container>
  );
};

export default CardDesktop;
